import { Immutable } from "immer";
import React, { useEffect } from "react";

import { getDocument } from "@thelabnyc/thelabui/src/utils/dom";

import { IFormUUID, IReviewsProductTypeID } from "../../../models/nominals";
import { useAppDispatch } from "../../../store/reducers";
import { WriteReviewButton } from "../WriteReviewButton";
import { WriteReviewForm } from "../WriteReviewForm";
import { WriteReviewThankYou } from "../WriteReviewThankYou";
import { WriteReviewFormMode } from "../constants";
import { registerNewWriteReviewForm } from "../reducers";

type IProps = Immutable<{
    formUUID: IFormUUID;
    brand?: string;
    displayedProductTypeIDWhitelist?: readonly IReviewsProductTypeID[];
}>;

export const SingleProductCollapsibleWriteReviewForm = (
    props: IProps,
): React.JSX.Element => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(
            registerNewWriteReviewForm({
                formUUID: props.formUUID,
                mode: WriteReviewFormMode.CLOSED,
            }),
        );
    }, [props.formUUID, dispatch]);

    const onReviewSubmit = () => {
        const document = getDocument();
        if (!document) {
            return;
        }
        const reviewModuleTitle = document.querySelector(
            ".write-review-button__container",
        );
        reviewModuleTitle?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <div className="write-review-button__container">
            <WriteReviewButton formUUID={props.formUUID} />
            <WriteReviewForm
                formUUID={props.formUUID}
                formTitle={"Choose your product"}
                brand={props.brand}
                displayedProductTypeIDWhitelist={
                    props.displayedProductTypeIDWhitelist
                }
                onReviewSubmit={onReviewSubmit}
            />
            <WriteReviewThankYou formUUID={props.formUUID} />
        </div>
    );
};
